import React from "react";

import Close from "../assets/svg/close.svg";
import { motion } from "framer-motion";
import { connect } from "react-redux";

function SelectExercisesNew(props) {
  const { exercises, off, cat } = props;

  const exercises_list =
    exercises && exercises.length
      ? exercises.map((exercise, index) => {
          //console.log(selected);
          return (
            <li
              className="listali"
              key={exercise.name}
              style={
                exercise.isPremium
                  ? {
                      textDecoration: "none",
                      pointerEvents: "none",
                    }
                  : {}
              }
            >
              <div
                style={
                  exercise.isPremium
                    ? { background: "rgba(255, 255, 255, 0.1)" }
                    : {}
                }
              >
                <input
                  type="checkbox"
                  id={"cb" + exercise.name}
                  name={exercise.name}
                  disabled
                  /*ref={this.selected[exercise.name]}*/
                />
                <label htmlFor={"cb" + exercise.name}>
                  <img
                    src={`https://cdn.fitzet.com/static%2F${exercise.name}.jpg?alt=media`}
                    alt={exercise.formatted}
                  />{" "}
                  <p style={{ textTransform: "capitalize" }}>
                    {exercise.formatted}{" "}
                    <font style={{ color: "#69C9D0" }}>
                      {exercise.isPremium ? "Premium" : null}
                    </font>
                  </p>
                </label>
              </div>
            </li>
          );
        })
      : null;

  return (
    <motion.div
      className="Yalla2"
      style={{
        background: "#EE1D52",
        padding: "20px 0px",
        position: "absolute",
        zIndex: 9999999,
        overflow: "hidden",
      }}
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", duration: 0.4 }}
    >
      <div style={{ float: "left", marginLeft: "10px", marginTop: "0px" }}>
        <span style={{ fontSize: "16px", fontWeight: 600 }}>
          PREMIUM <font style={{ color: "#69C9D0" }}>{cat.toUpperCase()}</font>{" "}
          EXERCISES
        </span>
      </div>

      <div
        style={{ float: "right", marginRight: "10px" }}
        onClick={(e) => {
          off(false, null);
        }}
      >
        <img src={Close} alt="close" style={{ maxHeight: "20px" }}></img>
      </div>
      <div style={{ height: "20px", overflow: "hidden" }}></div>
      <div
        style={{
          paddingTop: "10px",
          overflowY: "scroll",
          WebkitOverflowScrolling: "touch",
          height: "100%",
          width: "100%",
        }}
        className="yalla"
      >
        <ul className="listaul">{exercises_list}</ul>

        <p style={{ padding: "15px" }}>
          <button
            style={{
              fontSize: "18px",
              background: "#000",
              padding: "10px",
              border: 0,
              borderRadius: "4px",
              fontWeight: "600",
              width: "100%",
              color: "white",
            }}
            onClick={(e) => {
              off(false, null);
            }}
          >
            Close{" "}
            <span role="img" aria-label="like">
              ❌
            </span>
          </button>
        </p>

        <div style={{ height: "260px" }}></div>
      </div>
    </motion.div>
  );
}

export default connect(null, null)(SelectExercisesNew);
